/**
 * @generated SignedSource<<574eab891075aa9ce8c8b48787d54b32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignedActorText_actor$data = {
  readonly __typename: "ConnectActor";
  readonly employee: {
    readonly name: string;
  } | null;
  readonly identifyingName: string | null;
  readonly " $fragmentType": "SignedActorText_actor";
} | {
  readonly __typename: "GroupActor";
  readonly employee: {
    readonly name: string;
  } | null;
  readonly identifyingName: string | null;
  readonly " $fragmentType": "SignedActorText_actor";
} | {
  readonly __typename: "ScreenActor";
  readonly screen: {
    readonly name: string;
  } | null;
  readonly " $fragmentType": "SignedActorText_actor";
} | {
  readonly __typename: "UserActor";
  readonly storeUser: {
    readonly employee: {
      readonly name: string;
    } | null;
    readonly user: {
      readonly email: string;
      readonly name: string;
    };
  } | null;
  readonly " $fragmentType": "SignedActorText_actor";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "SignedActorText_actor";
};
export type SignedActorText_actor$key = {
  readonly " $data"?: SignedActorText_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignedActorText_actor">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignedActorText_actor",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StorecastScreen",
          "kind": "LinkedField",
          "name": "screen",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "type": "ScreenActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "type": "GroupActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/)
      ],
      "type": "ConnectActor",
      "abstractKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};
})();

(node as any).hash = "143edc9e2ea5ad95167fba10e2adec7c";

export default node;
